import { render, staticRenderFns } from "./ViewProject.vue?vue&type=template&id=32927fa0&scoped=true&"
import script from "./ViewProject.vue?vue&type=script&lang=ts&"
export * from "./ViewProject.vue?vue&type=script&lang=ts&"
import style0 from "./ViewProject.vue?vue&type=style&index=0&id=32927fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32927fa0",
  null
  
)

export default component.exports